const { AMO_COMPLETED_ID, AMO_ABORTED_ID } = require("./consts");

module.exports.validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

module.exports.validatePassword = (password) => {
    return password.length >= 8;
};

module.exports.isValidDate = (date) => {
    return date.getTime() === date.getTime();
}

module.exports.orderStatus = (order) => {
    const lastDone = order.statuses.done[order.statuses.done.length - 1];
    if (!lastDone || order.statuses.in_progress) return "in_progress";
    if (lastDone.amo_id == AMO_COMPLETED_ID) return "done";
    if (lastDone.amo_id == AMO_ABORTED_ID) return "aborted";
}

module.exports.deleteAllCookies = () => {
    // Получаем все куки
    const cookies = document.cookie.split(";");

    // Удаляем каждый куки
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

        // Устанавливаем срок действия в прошлое
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
}

module.exports.russianMonth = {
    1: "Январь",
    2: "Февраль",
    3: "Март",
    4: "Апрель",
    5: "Май",
    6: "Июнь",
    7: "Июль",
    8: "Август",
    9: "Сентябрь",
    10: "Октябрь",
    11: "Ноябрь",
    12: "Декабрь",
}

module.exports.pad = (number, padding) => {
    if (padding == undefined)
        padding = 2;

    return (new Array(padding).join('0') + number).slice(-padding);
}

module.exports.flatOrderStatuses = (order) => {
    let statuses = [...order.statuses.done];

    if (order.statuses.in_progress) {
        statuses = [...statuses, order.statuses.in_progress];
    }

    statuses = [...statuses, ...order.statuses.next];

    return statuses;
}

module.exports.orderStatusPercentage = (order) => {
    const statuses = module.exports.flatOrderStatuses(order);
    return Math.round(100 / statuses.length * order.statuses.done.length);
}

function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
}

module.exports.copyTextToClipboard = (text) => {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
        console.error('Async: Could not copy text: ', err);
    });
}

